/* SAGUIR — ajustes de experiencia de usuario (v33 móvil + v34 sitio). */
(function () {
  var mobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    /* v33 · Carrusel destacado del Drop 01 en móvil: fotos nítidas al ocupar ~70% del ancho */
    if (mobile) {
      document.querySelectorAll('[id$="__featured_products"] .card img[srcset]').forEach(function (img) {
        img.sizes = '70vw';
      });
    }

    /* v34 · Orden del catálogo: solo Novedades, Destacados y A–Z */
    var keep = { 'created-descending': 'Novedades', 'manual': 'Destacados', 'title-ascending': 'Nombre, A–Z' };
    document.querySelectorAll('select[name="sort_by"]').forEach(function (sel) {
      Array.prototype.slice.call(sel.options).forEach(function (o) {
        if (keep[o.value]) { o.textContent = keep[o.value]; }
        else if (!o.selected) { o.remove(); }
      });
    });

    /* v34 · Filtro de color heredado de piezas antiguas: se oculta hasta configurar los filtros nuevos */
    document.querySelectorAll('input[name^="filter.v.option.color"]').forEach(function (inp) {
      var box = inp.closest('details');
      if (box) box.style.display = 'none';
    });

    /* v34 · Menú móvil: contacto e Instagram */
    var drawer = document.querySelector('#menu-drawer .menu-drawer__navigation');
    if (drawer && !document.querySelector('.saguir-drawer-extra')) {
      var extra = document.createElement('div');
      extra.className = 'saguir-drawer-extra';
      extra.innerHTML = '<a href="mailto:info@saguir.com">info@saguir.com</a><a href="https://www.instagram.com/mercedessaguir" target="_blank" rel="noopener">Instagram</a>';
      drawer.parentNode.insertBefore(extra, drawer.nextSibling);
    }

    /* v34 · Carrito: cuánto falta para el envío gratis (150 € en España, Portugal y UE) */
    var UMBRAL = 15000;
    function euros(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
    function pintar(total) {
      var target = document.querySelector('.cart__footer .totals') || document.querySelector('.cart__footer');
      if (!target) return;
      var box = document.querySelector('.saguir-freeship');
      if (!box) {
        box = document.createElement('p');
        box.className = 'saguir-freeship';
        box.setAttribute('role', 'status');
        target.parentNode.insertBefore(box, target);
      }
      if (total <= 0) { box.hidden = true; return; }
      box.hidden = false;
      box.innerHTML = total >= UMBRAL
        ? '<strong>Tu pedido tiene envío gratis</strong> a España, Portugal y la Unión Europea.'
        : 'Te faltan <strong>' + euros(UMBRAL - total) + '</strong> para el envío gratis a España, Portugal y la Unión Europea.';
    }
    function refrescar() {
      if (!document.querySelector('.cart__footer')) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { pintar(c.total_price); })
        .catch(function () {});
    }
    refrescar();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('cart-items')) setTimeout(refrescar, 900);
    });
  });
})();
